import React from 'react';

type IconProps = React.SVGProps<SVGSVGElement> & {
    viewBox?: string;
};

const SearchIcon: React.FC<IconProps> = ({
        viewBox = '0 0 16 16',
        ...props
    }) => {
    return (
        <svg
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            viewBox={viewBox}
            style={{flexShrink: 0}}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.49668 9.9765L6.49668 10.5032L3.16335 13.8298L2.17002 12.8365L5.49668 9.50316L6.02335 9.50316L6.21002 9.32316C5.55668 8.56316 5.16335 7.5765 5.16335 6.50316C5.16335 4.10983 7.10335 2.16983 9.49668 2.16983C11.89 2.16983 13.83 4.10983 13.83 6.50316C13.83 8.8965 11.89 10.8365 9.49668 10.8365C8.42335 10.8365 7.43668 10.4432 6.67668 9.78983L6.49668 9.9765ZM9.49661 3.50347C7.83661 3.50347 6.49661 4.84347 6.49661 6.50347C6.49661 8.16347 7.83661 9.50347 9.49661 9.50347C11.1566 9.50347 12.4966 8.16347 12.4966 6.50347C12.4966 4.84347 11.1566 3.50347 9.49661 3.50347Z"
            />
        </svg>
    );
};

export default SearchIcon;